













import Vue from "vue";

export default Vue.extend({
  name: "TopNavLink",
  props: ["alert", "active", "link"]
});
